export enum SortingType {
    RELEVANCE = "",
    TUITION_FEE_ASC = "tuition"
}
